// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__JysZG","label":"CategoryService_label__3WBKY","location":"CategoryService_location__1xmZk"};